import { render, staticRenderFns } from "./ProjectValuationExternalReportPage8.vue?vue&type=template&id=0c4c63b4&"
import script from "./ProjectValuationExternalReportPage8.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationExternalReportPage8.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports